/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteOrganizationUserSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteOrganizationUserSessionIssuerRequest = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteOrganizationUserSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationUserSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationUserSessionIssuerSecurity$Outbound,
    DeleteOrganizationUserSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteOrganizationUserSessionIssuerSecurityToJSON(
  deleteOrganizationUserSessionIssuerSecurity:
    DeleteOrganizationUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    DeleteOrganizationUserSessionIssuerSecurity$outboundSchema.parse(
      deleteOrganizationUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type DeleteOrganizationUserSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationUserSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationUserSessionIssuerRequest$Outbound,
    DeleteOrganizationUserSessionIssuerRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function deleteOrganizationUserSessionIssuerRequestToJSON(
  deleteOrganizationUserSessionIssuerRequest:
    DeleteOrganizationUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    DeleteOrganizationUserSessionIssuerRequest$outboundSchema.parse(
      deleteOrganizationUserSessionIssuerRequest,
    ),
  );
}
